import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetTerms = createAsyncThunk<AxiosResponse<any, any>, any>(
  "terms/toGetTerms",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/terms-conditions?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
